import { gql } from "@apollo/client";
import { Box, Flex, Image, Stack, Text } from "@chakra-ui/react";
import React from "react";
//@ts-ignore
import Zoom from "react-reveal/Zoom";
import { useHistory } from "react-router-dom";
import { getRole } from "utils/functions";
import logo from "../assets/img/logo.png";
import LoginForm from "../components/LoginPage";

interface Props {}

const Login: React.FC<Props> = () => {
  const history = useHistory();
  const role = getRole(); // localStorage.getItem("role");

  if (
    role !== null &&
    (role === "Client" || role === "Authenticated" || role === "Cashier")
  ) {
    history.push("/");
    return <></>;
  }

  return (
    <Stack minH={"100vh"} direction={{ base: "column-reverse", md: "row" }}>
      <Flex p={8} flex={1} align={"center"} justify={"center"}>
        <LoginForm />
      </Flex>
      <Flex
        flex={1}
        justifyContent="center"
        alignItems={"center"}
        bg="orange.100"
        position={"relative"}
        minH={{ base: "40vh", md: "100vh" }}
      >
        <Box textAlign={"center"} color="orange.500" px="3">
          <Zoom>
            <Image src={logo} mt="-10" />
          </Zoom>
          <Text
            fontSize={{ base: "lg", md: "xl" }}
            color="gray.600"
            mt="-12"
            fontFamily={"Lexend"}
            letterSpacing="wider"
            textTransform={"uppercase"}
          >
            <Zoom delay={400}>Online Classes</Zoom>
          </Text>
          <Text
            fontSize={{ base: "lg", md: "2xl" }}
            color="gray.600"
            fontFamily={"Lexend"}
          >
            <Zoom delay={600}>වීර්යය කරන්නා අධිශ්ඨානය කරා ළගා වෙයි</Zoom>
          </Text>
        </Box>
      </Flex>
    </Stack>
  );
};

export default Login;

const ME_QUERY = gql`
  query ME_QUERY {
    me {
      role {
        name
      }
    }
  }
`;
